import { defineStore } from "pinia";

export const useVerifyStore = defineStore("verify", () => {
  const { $api } = useNuxtApp();
  //   const authStore = useAuthStore();

  async function verifyPassword(verifyToken: string) {
    const data = await $fetch($api(`/password/confirm?token=${verifyToken}`), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).catch((err) => err.data);

    return data;
  }

  async function forgotPassword(email: string) {
    const data = await $fetch($api(`/password/forgot`), {
      method: "POST",
      body: { email },
      headers: {
        "Content-Type": "application/json",
      },
    }).catch((err) => err.data);
    return data;
  }
  async function verifyOtp(email: string, otp: string) {
    const data = await $fetch($api(`/password/verify-otp`), {
      method: "POST",
      body: { email, otp },
      credentials: "include", // CRITICAL: Include credentials to receive session cookie
      headers: {
        "Content-Type": "application/json",
      },
    }).catch((err) => err.data);
    return data;
  }

  async function verifyEmail(verifyToken: string) {
    const url = $api(`/auth/user/verify-email/${verifyToken}`);
    const data = await $fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).catch((err) => err.data);

    return data;
  }

  async function confirmEmailChange(verifyToken: string) {
    try {
      const url = $api(`/profile/confirm-email?token=${verifyToken}`);
      const data = await $fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }).catch((err) => err.data);

      return data;
    } catch (error) {
      console.error("Error confirming email change:", error);
      return { error: error };
    }
  }

  return {
    forgotPassword,
    verifyPassword,
    verifyEmail,
    confirmEmailChange,
    verifyOtp,
  };
});
